import { Transitions } from "../../../common/components/Transitions";
import { useEffect, useState } from "react";
import { AssessmentShell } from "../components/AssessmentShell";
import { useNavigate } from "react-router";
import { NavItems } from "../../../common/helpers/navigation";
import { sleepFor } from "../../../common/helpers/countHelper";
import { useAppSelector } from "../../../app/hooks";
import { getInstructionFromStep } from "../../../common/helpers/instructionHelper";
import { enableKeyBoard, toggleFullScreenOff } from "../../../common/helpers/fullScreenHelper";
import VideoPlayer from "@components/VideoPlayer";

const THANK_YOU = "Thank You & Confirmation Screen";

export const AssessmentClosingVideo = (): JSX.Element => {
    const [errorLoadingVideo, setErrorLoadingVideo] = useState(false);

    const navigate = useNavigate();

    // Eventually get instructions from step: CLOSINGVIDEO
    const closingInstruction = useAppSelector((x) => getInstructionFromStep(x.assessmentForm.instructions, THANK_YOU));

    const [currentCaption, setCurrentCaption] = useState("");

    // TODO: handle CC from ccType as a handler that changes currentCaption
    useEffect(() => {
        if (errorLoadingVideo) {
            const instructions = closingInstruction.instructionText.split(";");

            instructions.forEach((instruction, index) => {
                setTimeout(() => {
                    setCurrentCaption(instruction);
                }, index * 3 * 1000);
            });

            setTimeout(() => {
                void handleOnEnd();
            }, (instructions.length + 1) * 3 * 1000);
        }
    }, [errorLoadingVideo]);

    const handleOnVideoError = (): void => {
        setErrorLoadingVideo(true);
    };

    const handleOnEnd = async (): Promise<void> => {
        await sleepFor(3);
        enableKeyBoard();
        void toggleFullScreenOff();

        navigate(NavItems.Assessments.AssessmentComplete.path);
    };

    return (
        <AssessmentShell>
            {errorLoadingVideo && <Transitions currentCaption={currentCaption} />}
            {!errorLoadingVideo && (
                <VideoPlayer
                    url={closingInstruction.instructionVideoUrl}
                    onLoadError={handleOnVideoError}
                    onEnd={handleOnEnd}
                />
            )}
        </AssessmentShell>
    );
};
